import {
    Box,
    Button,
    Divider,
    FormControl,
    FormControlLabel,
    Grid,
    IconButton,
    InputLabel,
    MenuItem,
    Radio,
    RadioGroup,
    Select,
    TextField,
    Typography
} from "@material-ui/core";
import {ArrowForward, ArrowRight, CheckCircleOutline, Search, SignalCellularNullRounded} from "@material-ui/icons";
import {makeStyles} from '@material-ui/core/styles';
import {useEffect, useState} from "react";
import FullscreenLoading from "../../Common/FullscreenLoading";
import _ from "lodash";


const useStyles = makeStyles((theme) => ({
        row: {
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center'
        },
        verticalMargin: {
            marginTop: theme.spacing(2),
            marginBottom: theme.spacing(2)
        },
        textSpace: {
            marginRight: theme.spacing(1)
        }
    }))

;

export default function TransferBar(props) {
    const [fullscreenLoading, setFullscreenLoading] = useState(false);
    const validBatchNumberRegex = /^[A-Z]+SUB-20\d{10}$/
    const validThirdPartBatchRegex = /^[A-Z]{3}-[A-Z]{2}-\d{8}$/
    const classes = useStyles();
    const [uiAssignModeRadio, setUiAssignModeRadio] = useState("1"); //MUST BE A STRING 0 = manual, 1 = auto
    const [manualBatchNumber, setManualBatchNumber] = useState("");


    return (
        <Box>
            <div className={`${classes.row} ${classes.verticalMargin}`}>
                <div style={{flex: 2}}>
                    <RadioGroup row value={uiAssignModeRadio} onChange={(event) => {
                        console.log(event.target.value);
                        setUiAssignModeRadio(event.target.value)
                    }}>
                        <FormControlLabel
                            value="1"
                            control={<Radio color='secondary'/>}
                            label="Auto Assign"
                        />
                        <FormControlLabel
                            value="0"
                            control={<Radio color='secondary'/>}
                            label="Manual Assign"
                        />
                    </RadioGroup>
                    {uiAssignModeRadio === "0" ?
                        <div>
                            <Typography>Manual assign mode: please provide a batch number</Typography>
                            <TextField
                                variant='outlined'
                                placeholder="Batch Number"
                                style={{minWidth: 300}}
                                onChange={(event) => setManualBatchNumber(event.target.value)}
                                error={manualAssignBatchValidate()}
                                helperText={manualAssignBatchValidate() ? 'Invalid batch number' : null}
                            />
                        </div>
                        :
                        <Typography>Auto assign mode: system will automatically assign a batch number</Typography>
                    }
                </div>
                <div style={{display: 'flex', flex: 1, justifyContent: 'center'}}>
                    <Button
                        variant="contained"
                        endIcon={<ArrowForward/>}
                        color='primary'
                        disabled={!props.stepOneComplete || !props.stepTwoComplete || manualAssignBatchValidate()}
                        onClick={() => handleTransferOrders()}
                    >
                        Transfer
                    </Button>
                </div>
            </div>


            <FullscreenLoading open={fullscreenLoading}/>
        </Box>
    )

    function manualAssignBatchValidate() {
        if (!_.isNil(manualBatchNumber)) {
            if (uiAssignModeRadio === "0" && !validBatchNumberRegex.test(manualBatchNumber.trim()) && !validThirdPartBatchRegex.test(manualBatchNumber.trim())) {
                return true
            }
        }
        return false
    }

    function handleTransferOrders() {

        props.handleAbleTransit(true);
        props.handleuiAssignModeRadio(uiAssignModeRadio);
        if (!_.isNil(manualBatchNumber)) {
            props.handleManualBatchNumber(manualBatchNumber.trim())
        } else
            props.handleManualBatchNumber(manualBatchNumber)
    }

}